import { Button } from '../../ui/Button.tsx';
import { PasswordForm } from '../account/PasswordForm.tsx';
import { useAuth } from './auth-context.ts';

// Tras un alta o un reseteo, la clave es temporal: la app exige cambiarla antes de continuar
// (el servidor también bloquea las operaciones con password_change_required).
export function ForcePasswordChange() {
  const { refreshProfile, signOut } = useAuth();
  return (
    <div className="page page-narrow">
      <h1>Cambia tu contraseña</h1>
      <section className="card">
        <p>Estás usando una contraseña temporal. Elige una contraseña nueva que solo tú conozcas para continuar.</p>
        <PasswordForm submitLabel="Guardar y continuar" onChanged={refreshProfile} />
      </section>
      <Button variant="ghost" onClick={() => void signOut()}>
        Cerrar sesión
      </Button>
    </div>
  );
}
